import Element, { ElementType, SpecyficType } from './element';
import { Vector2, Vector3, Mesh } from '@babylonjs/core';

export class SlotElement extends Element {

    public slotType: ElementType = ElementType.OTHER;
    public slotSpecyficType: SpecyficType = SpecyficType.OTHER;

    constructor(
        public position: Vector2,
        public shape: Vector2,
        public meshes: Mesh[],
        public shelfSlot: boolean = false,
    ) {
        super(
            '',
            '',
            '',
            position,
            shape,
            meshes,
        );
    }

    public get center(): Vector3 {
        return this.meshes[0].position;
    }

    public set center(position: Vector3) {
        this.meshes[0].position = position;
    }

    protected setBoundingInfo() {
        // hook
    }
}
